var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from 'react';
import { useField } from './useField';
export function useHtmlField(initialState, validator, options) {
    if (validator === void 0) { validator = function () { return null; }; }
    var field = useField(initialState, validator, options);
    var onChange = useCallback(function (e) {
        field.setValue(e.target.value);
    }, [field]);
    return __assign(__assign({}, field), { onChange: onChange });
}
//# sourceMappingURL=useHtmlField.js.map